module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.11917/img/callout-blobs.svg"